/* Home 2609 – Since Tippsy
   Same video handling as the Hero (decided):
   - load one video for the current screen size (767px and below: mobile, 768px and up: desktop)
   - no autoplay when reduced motion is on (the poster stays)
   - the play / pause button (the theme's video-controls snippet)
   The section sits low on the page, so nothing is loaded until it comes near the screen (decided 2026-10-20);
   until then the poster shows. */
(function () {
  var MOBILE = window.matchMedia('(max-width: 767.98px)');
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  function videosOf(wrap) {
    var all = wrap.querySelectorAll('video[data-src]');
    var pick = null;
    var rest = [];
    for (var i = 0; i < all.length; i++) {
      var size = all[i].getAttribute('data-size');
      var match = size === 'all' || (size === 'sm' && MOBILE.matches) || (size === 'lg' && !MOBILE.matches);
      if (match && !pick) pick = all[i];
      else rest.push(all[i]);
    }
    return { pick: pick, rest: rest };
  }

  function sync(wrap) {
    var v = videosOf(wrap);
    for (var j = 0; j < v.rest.length; j++) v.rest[j].pause();
    var shouldPlay = !REDUCED.matches && wrap.getAttribute('data-paused') !== 'true';
    if (v.pick && shouldPlay) {
      if (!v.pick.getAttribute('src')) v.pick.setAttribute('src', v.pick.getAttribute('data-src'));
      var p = v.pick.play();
      if (p && p.catch) p.catch(function () {});
    } else if (v.pick) {
      v.pick.pause();
    }
    wrap.classList.toggle('on', !!(v.pick && shouldPlay));
    wrap.classList.toggle('off', !(v.pick && shouldPlay));
  }

  function bindButton(wrap) {
    var btn = wrap.querySelector('[data-hook="play-pause"]');
    if (!btn) return;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (wrap.classList.contains('on')) {
        wrap.setAttribute('data-paused', 'true');
      } else {
        wrap.removeAttribute('data-paused');
        // a click is an explicit request to play, even under reduced motion
        var v = videosOf(wrap).pick;
        if (v) {
          if (!v.getAttribute('src')) v.setAttribute('src', v.getAttribute('data-src'));
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
          wrap.classList.add('on');
          wrap.classList.remove('off');
          return;
        }
      }
      sync(wrap);
    });
  }

  function init(wrap) {
    if (!wrap || wrap.h2609Ready) return;
    wrap.h2609Ready = true;
    bindButton(wrap);
    if (!('IntersectionObserver' in window)) {
      wrap.h2609Near = true;
      sync(wrap);
      return;
    }
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          wrap.h2609Near = true;
          sync(wrap);
          obs.disconnect();
        }
      });
    }, { rootMargin: '400px 0px' });
    io.observe(wrap);
  }

  function initAll(scope) {
    var wraps = (scope || document).querySelectorAll('[data-h2609-tippsy][data-h2609-video]');
    for (var i = 0; i < wraps.length; i++) init(wraps[i]);
  }

  function onMediaChange() {
    var wraps = document.querySelectorAll('[data-h2609-tippsy][data-h2609-video]');
    for (var i = 0; i < wraps.length; i++) if (wraps[i].h2609Near) sync(wraps[i]);
  }
  if (MOBILE.addEventListener) {
    MOBILE.addEventListener('change', onMediaChange);
    REDUCED.addEventListener('change', onMediaChange);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  // Theme editor
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
